import Navbar from "./components/navbar";
import Introduction from "./components/introduction";
import Howwework from "./components/howwework";
import Findout from "./components/findout";
import Footer from "./components/footer";
import Mobilemenu from "./components/mobilemenu";
import { useState } from "react";

function App() {
  const [mobilenavopen, setMobilenavopen] = useState(false);
  return (
    <div
      id="maincontainer"
      style={mobilenavopen ? { overflow: "hidden" } : { overflow: "auto" }}
    >
      <Navbar setMobilenavopen={setMobilenavopen} />
      <Mobilemenu mobilenavopen={mobilenavopen} />
      <Introduction />
      <Howwework />
      <Findout />
      <Footer />
    </div>
  );
}

export default App;
